import {
  type BuildDetailsFieldsParams,
  checkboxField,
  field,
  leftColumn,
  rightColumn,
  selectField,
  typedField,
  withLayout,
} from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildPaymentDetailsFields({ opportunity }: BuildDetailsFieldsParams): Array<DetailField> {
  const contract = opportunity?.contract;
  const contractAndCommercial = opportunity?.contract_and_commercial;
  const productAndSoloTraveller = opportunity?.product_and_solo_traveller;
  const keyCommercial = opportunity?.key_commercial;

  return [
    selectField(
      'Payment Method',
      contract?.payment_method__c,
      ['VCC(Citibank)', 'Bank Transfer', 'Credit Card'],
      undefined,
      leftColumn,
    ),
    typedField('Admin Fee (%)', contractAndCommercial?.admin_fee__c, 'number', undefined, leftColumn),
    withLayout(
      field(
        'Payment Milestone',
        contract?.payment_milestone__c,
        'Use this picklist field to assign the payment breakdown to be used.',
      ),
      leftColumn,
    ),
    selectField(
      'Product Segment',
      productAndSoloTraveller?.product_segment__c,
      ['Escapes', 'Tours', 'Cruises'],
      undefined,
      leftColumn,
    ),
    typedField(
      'Chain Margin Contribution (%)',
      keyCommercial?.chain_margin_contribution__c,
      'number',
      undefined,
      leftColumn,
    ),
    withLayout(
      field(
        'LE Marketing Terms',
        productAndSoloTraveller?.le_hotel_chains__c,
        'Use this picklist field to assign the marketing term to be merged into the contract.',
      ),
      leftColumn,
    ),
    checkboxField('PCM Margin Deduction', contractAndCommercial?.pcm_margin_deduction__c, undefined, {
      ...leftColumn,
      compact: true,
    }),
    checkboxField(
      'Deal with Special Payment Terms',
      contractAndCommercial?.deal_with_special_payment_terms__c,
      undefined,
      { ...leftColumn, compact: true },
    ),
    selectField(
      'LE Contracts Geo',
      contract?.le_contracts_geo__c,
      ['International', 'Australia', 'USA', 'Europe', 'Asia'],
      'This picklist field is used to determine how tax impacts the margin calculation and which marketing terms are to be merged into the contract.',
      rightColumn,
    ),
    withLayout(
      field('Special Payment Terms Notes', contractAndCommercial?.special_payment_terms_notes__c, undefined, true),
      rightColumn,
    ),
    checkboxField(
      'City/Other Tax Payable Direct',
      contract?.city_other_tax__c,
      'Are there any City/State/Tourist taxes that are payable direct?',
      rightColumn,
    ),
    withLayout(
      field(
        'City/Other Tax Details',
        contract?.city_tax_comments__c ?? contract?.city_other_tax__c,
        'Amount payable, per person per night, in contracted currency.',
        true,
      ),
      rightColumn,
    ),
  ];
}
